<div class="bz-dialog">
  @if (heading()) {
    <div class="bz-dialog__header">
      <div class="bz-dialog__headings">
        <h2 mat-dialog-title class="bz-dialog__title">{{ heading() }}</h2>
        @if (subheading()) {
          <p class="bz-dialog__subtitle">{{ subheading() }}</p>
        }
      </div>

      @if (dismissible()) {
        <bz-button
          variant="tertiary"
          size="sm"
          type="button"
          ariaLabel="Close dialog"
          (clicked)="dismiss()"
        >
          <bz-icon [icon]="closeIcon" size="xl" />
        </bz-button>
      }
    </div>
  }

  <mat-dialog-content class="bz-dialog__content">
    <ng-content select="[bzDialogContent]" />
  </mat-dialog-content>

  <mat-dialog-actions class="bz-dialog__actions">
    <ng-content select="[bzDialogActions]" />
  </mat-dialog-actions>

  @if (resizable) {
    <!-- Sits above the footer on purpose: the corner is exactly where the
         primary action is, and whichever is on top gets the pointer. -->
    <span
      class="bz-dialog__resize"
      role="separator"
      aria-orientation="horizontal"
      aria-label="Resize dialog"
      (pointerdown)="onResizeStart($event)"
      (pointermove)="onResizeMove($event)"
      (pointerup)="onResizeEnd($event)"
      (pointercancel)="onResizeEnd($event)"
    ></span>
  }
</div>
